import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { FormGroup, Switch } from "@blueprintjs/core";
import { IntegrationStore } from "../../stores/xml-integracao/IntegrationStore";
import { toast } from "react-toastify";

@observer
export default class Questor extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props: {}) {
    super(props);
  }

  async handleSaveToken(newValue: boolean) {

    if (IntegrationStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Você precisa selecionar uma empresa.', {});
      return
    }

    let data = {
      cnpj: IntegrationStore.obs.selectedEmpresa.cnpj,
      envio_automatico: newValue,
      tipo: "questor"
    }

    await IntegrationStore.handleSaveToken(data)

  }

  handleChangeEnvio = async (e) => {

    const newValue = e.target.checked;

    IntegrationStore.obs.envio_automatico_questor_api = newValue

    await this.handleSaveToken(newValue)

  };

  render() {

    return (
      <>

        <FormGroup label="Envio Automático">
          <Switch
            label={IntegrationStore.obs.envio_automatico_questor_api ? "Ativado" : "Desativado"}
            checked={IntegrationStore.obs.envio_automatico_questor_api}
            onChange={(e: any) => this.handleChangeEnvio(e)} />
        </FormGroup>

      </>
    )
  }


}